<h2 mat-dialog-title fxLayoutAlign="center">{{ data.title }}</h2>
<mat-dialog-content fxLayoutAlign="center">
  <mat-selection-list
    style="width: 100%; max-height: 300px"
    [formControl]="selectItemControl"
    [multiple]="false"
    hideSingleSelectionIndicator
    (selectionChange)="closeDialog(selectItemControl.value[0])"
  >
    @for (magazine of data.magazineIssues; track magazine) {
      <mat-list-option [value]="magazine">
        <img
          class="magaine-jacket-art"
          matListAvatar
          [src]="magazine.images.thumbnail.href"
          [attr.alt]="magazine.edition"
        />
        {{ magazine.edition }}
      </mat-list-option>
    }
  </mat-selection-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button aria-label="Cancel" mat-dialog-close type="button">Cancel</button>
</mat-dialog-actions>
